import React from 'react';
import { connect } from 'react-redux';
import { selectAssetUrlById, selectCollectionIdById, selectOpenByDefaultById, updateAssetUrlByIds } from './_redux';
import { SvgInputControlAccordion } from './partials/SvgInputControlAccordion';
import { SvgInputControlModal } from './partials/SvgInputControlModal';
import { AppDispatch, WebsiteState } from '@gift/website-state/store';
import { selectNameByVariableId } from '@gift/website-state/slices/variablesSlice';

const _SvgInputControl = (props: Props) => (
    <>
        <SvgInputControlAccordion {...props} />
        <SvgInputControlModal {...props} />
    </>
);

type Props = {
    variableIds: string[],
    name: string,
    collectionId: string,
    selectedAssetUrl: string,
    openByDefault: boolean,
    commit: (svgUrl: string) => void
};

const mapStateToProps = (state: WebsiteState, ownProps: { variableIds: string[] }) => ({
    name: selectNameByVariableId(state, ownProps.variableIds[0])!,
    collectionId: selectCollectionIdById(state, ownProps.variableIds[0])!,
    selectedAssetUrl: selectAssetUrlById(state, ownProps.variableIds[0])!,
    openByDefault: selectOpenByDefaultById(state, ownProps.variableIds[0])!
});

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: { variableIds: string[] }) => ({
    commit: (svgUrl: string) => dispatch(updateAssetUrlByIds(ownProps.variableIds, svgUrl))
});

export const SvgInputControl = connect(
    mapStateToProps,
    mapDispatchToProps
)(_SvgInputControl);